function hasScroll(element, className = 'is_scroll') {
	const div = element
	const is_scroll = div.scrollHeight > div.clientHeight && !(div.style.overflow && div.style.overflow === 'hidden')
	is_scroll ? div.classList.add(className) : div.classList.remove(className)
}

window.hasScroll = hasScroll
